<template>
  <SearchWithSingleSelect
    :disabled="disabled"
    displayValue
    :label="label"
    :loadingOptions="loading"
    name="Manager"
    :options="options"
    :totalOptions="options.length"
    :value="manager"
    @filter="search"
    @input="onInput"
  />
</template>

<script>
import {
  ItemTypeConsts,
  StoreModelMap,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapActions } from 'vuex';
import SearchWithSingleSelect from 'client/components/SearchWithSingleSelect/SearchWithSingleSelect.vue';

const systemUserCollection = StoreModuleMap[ItemTypeConsts.systemUser];
const systemUserModel = StoreModelMap[ItemTypeConsts.systemUser];

export default {
  name: 'SelectManagerField',

  components: {
    SearchWithSingleSelect,
  },

  props: {
    disabled: Boolean,

    label: {
      type: String,
      default: 'Manager',
    },

    value: {
      type: String,
      default: undefined,
    },
  },

  data: () => ({
    loading: true,
    options: [],
    manager: undefined,
  }),

  async beforeMount() {
    await this.getManagerFromValue();
    await this.search();
  },

  methods: {
    ...mapActions(systemUserCollection, [
      'listUsersForManager',
    ]),

    ...mapActions(systemUserModel, ['fetchManagerUser']),

    async getManagerFromValue() {
      this.loading = true;

      try {
        this.manager = await this.fetchManagerUser();
      } catch {
        this.manager = undefined;
      }

      this.loading = false;
    },

    onInput(obj) {
      let inputValue = null;
      this.manager = undefined;

      if (obj) {
        inputValue = obj.value;
        this.manager = obj;
      }

      this.$emit('input', inputValue);
    },

    async search(searchTerm = '') {
      this.loading = true;

      try {
        this.options = await this.listUsersForManager({ searchTerm });
      } catch {
        this.options = [];
      }

      this.loading = false;
    },
  },
};
</script>
